import * as yup from 'yup';

import { Employee, RolesEnum, UserStatusEnum } from 'types/user';

export const getInitialValues = (e: Employee | null) => ({
  fname: e?.fname || '',
  lname: e?.lname || '',
  role: e?.permissions?.[0]?.role || '',
  phone: e?.phone && e.phone !== '0' ? e.phone : '',
  email: e?.email || '',
  washHub: e?.permissions?.[0]?.washHub || '',
  isActive: e?.status !== UserStatusEnum.SUSPENDED,
});

export const rolesMap: Record<string, string> = {
  [RolesEnum.ADMIN]: 'Admin',
  [RolesEnum.SUPER_ADMIN]: 'Super Admin',
  [RolesEnum.WASH_HUB_ADMIN]: 'Wash Hub Admin',
  [RolesEnum.WASH_HUB_STAFF]: 'Wash Hub Staff',
  // [RolesEnum.CUSTOMER]: 'Customer',
};

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const validationSchema = yup.object().shape({
  fname: yup.string().min(3).required('First name is required field'),
  lname: yup.string().min(3).required('Last name is required field'),
  email: yup.string().email().required(),
  role: yup.string().required('Role name is required field'),
  phone: yup
    .string()
    .nullable()
    .test('phone', 'Phone number is not valid', function (value) {
      if (!value || value.length === 0 || value === '0') return true; // Allow empty or "0"
      return phoneRegExp.test(value);
    }),
  washHub: yup.string().optional(),
  isActive: yup.boolean(),
});
